// extracted by mini-css-extract-plugin
export var content = "Ingridents-description-module--content--79b6c";
export var descriptionTitle = "Ingridents-description-module--description-title--f71eb";
export var displayContent = "Ingridents-description-module--display-content--bddd1";
export var productDiscription = "Ingridents-description-module--product-discription--848a9";
export var productIcon = "Ingridents-description-module--product-icon--46955";